import { Button, Card, CardContent, CardFooter, Icon, Separator } from "@elit-hair/elit-ui";
import { t } from "i18next";
import { TbExternalLink, TbPhoneOff, TbTrash } from "react-icons/tb";

import { LastCallPhoneNumbers } from "@/components/last-call-card/last-call-phone-numbers";
import { LastCallRecordInfo } from "@/components/last-call-card/last-call-record-info";
import { OpenRecordButton } from "@/components/ui/open-record-button";
import { useLastCallRecord } from "@/hooks/use-last-call-record";
import { useCall } from "@/providers/hooks/use-call";

export const LastCallCard = () => {
    const { isCallActive, handleHangupCall, callButtonCooldown } = useCall();
    const { lastCallRecord, clearLastCallRecord, callLastRecord } = useLastCallRecord();

    const hasActiveCall = isCallActive();

    return (
        <Card className="h-full w-full bg-transparent border-none">
            <CardContent className="flex flex-col w-full p-0 my-4">
                {lastCallRecord ? (
                    <>
                        <LastCallRecordInfo record={lastCallRecord.data} />
                        <LastCallPhoneNumbers
                            record={lastCallRecord.data}
                            moduleType={lastCallRecord.moduleType}
                            onCall={callLastRecord}
                        />
                    </>
                ) : (
                    <div className="text-center text-muted-foreground py-10 text-sm">{t("no_last_call_data")}</div>
                )}
            </CardContent>
            <Separator />
            <CardFooter className="w-full flex flex-col gap-2">
                {lastCallRecord && (
                    <div className="flex flex-col w-full gap-2 py-2">
                        <div
                            className={`overflow-hidden transition-all duration-300 ease-out ${
                                hasActiveCall
                                    ? "max-h-14 opacity-100 border-b border-secondary pb-2"
                                    : "max-h-0 opacity-0 pointer-events-none"
                            }`}
                        >
                            <Button
                                variant="destructive"
                                onClick={handleHangupCall}
                                disabled={callButtonCooldown}
                                className="w-full"
                            >
                                <Icon icon={TbPhoneOff} /> <span className="text-sm">{t("hang_up")}</span>
                            </Button>
                        </div>
                        <OpenRecordButton
                            id={lastCallRecord.data.id}
                            moduleType={lastCallRecord.moduleType}
                            brand={lastCallRecord.brand}
                            label={
                                <span className="flex items-center gap-2">
                                    {t("open_in_crm")} <Icon icon={TbExternalLink} />
                                </span>
                            }
                            disabled={!lastCallRecord.data.id || !lastCallRecord.moduleType}
                        />
                        <Button variant="ghost" onClick={clearLastCallRecord}>
                            <Icon icon={TbTrash} /> <span className="text-sm">{t("clear_last_call")}</span>
                        </Button>
                    </div>
                )}
            </CardFooter>
        </Card>
    );
};
